import React from 'react';

import { Modal } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import routes from 'app/routes';
import Form from '../Form/Index';
import { useContext } from '../../Context';

export default function Index() {
  const navigate = useNavigate();
  const { dispatch, actions, state } = useContext();
  const { resourceId } = useParams();

  const onSave = (values, successCallback, errorCallback) => {
    actions.update(dispatch, resourceId, values, () => {
      successCallback();
    }, (errors) => {
      errorCallback(errors);
    });
  };

  const row = state.resources === null ? null : state.resources.find((item) => item.id === resourceId);

  return (
    <Modal
      className="student inmodal auto without-overflow"
      show
      onHide={() => navigate(routes.admin.resources.index)}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Edit Resource
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {row === null ? 'Please wait ...' : <Form resource={row} onSave={onSave} />}
      </Modal.Body>
    </Modal>
  );
}
